<template>
    <div>
            <div class="table-responsive mt-3">
                <v-data-table
                    :headers="headersTabs"
                    :items="dessertsArea"
                    item-key="name"
                    :search="searchData"
                    :items-per-page="10"
                    class="elevation-1 table table-areas text-center align-middle"
                    loading
                    loading-text="Cargando..."
                    mobile-breakpoint="0"
                    :footer-props="{
                        prevIcon: 'fa-solid fa-chevron-left',
                        nextIcon: 'fa-solid fa-chevron-right',
                        'items-per-page-text': 'Mostrando: ',
                        'items-per-page-options': [5, 10, 20, 30, 40, 50],
                    }"
                >
                    <template v-slot:item="row">
                        <tr>
                            <td width="5%">{{ row.item.id }}</td>
                            <td width="5%">
                                <small>{{ row.item.area }}</small>
                            </td>
                            <td width="10%">
                                <small
                                    class="d-inline-block text-truncate"
                                    style="max-width: 115px"
                                    >{{ row.item.firstname }}
                                    {{ row.item.lastname }}</small
                                >
                            </td>
                            <td width="7%">
                                <small>{{
                                    row.item.client != null
                                        ? row.item.client.name
                                        : ""
                                }}</small>
                            </td>
                            <td width="5%">
                                {{
                                    row.item.info_statistics != null
                                        ? row.item.info_statistics
                                              .courses_started
                                        : 0
                                }}
                            </td>
                            <td width="5%">
                                {{
                                    row.item.info_statistics != null
                                        ? row.item.info_statistics
                                              .courses_completed
                                        : 0
                                }}
                            </td>
                            <td width="5%">
                                {{
                                    row.item.info_statistics != null
                                        ? row.item.info_statistics
                                              .failed_courses
                                        : 0
                                }}
                            </td>
                            <td width="5%">
                                {{
                                    row.item.info_statistics != null
                                        ? row.item.info_statistics
                                              .registered_routes
                                        : 0
                                }}
                            </td>
                            <td width="5%">
                                {{
                                    row.item.info_statistics != null
                                        ? row.item.info_statistics.insignia
                                        : 0
                                }}
                            </td>
                            <td width="5%">
                                {{
                                    row.item.info_statistics != null
                                        ? row.item.info_statistics.failed_routes
                                        : 0
                                }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
    </div>
</template>
<script></script>

<script>
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

export default {
    props: [
        "get",
        "headersTabsCompany",
        "urldatacompany",
        "urldataclient",
        "urldataarea",
        "datagraphics",
        "urlstudentsdetail",
        "urltotalcourses",
        "urlplanesgrafica",
        "urltotalroutes",
        "urltotalplanes",
        "urltotalclients",
        "urldataplanes",
        "urldatacourses",
        "urldataroutes",
        "urldatastudents",
        "allareas",
    ],
    data: function () {
        return {
            searchCompany: "",
            categories: [],
            searchData: "",
            insigniastotal: 0,
            tablaArea: false,
            dessertsGraphicArea: [],
            headersTabs: [
                { text: "No. de Áreas", value: "id" },
                { text: "Áreas de trabajo", value: "area" },
                { text: "Estudiante", value: "firstname" },
                { text: "Empresa", value: "client.name" },
                { text: "Cursos iniciados", value: "info_statistics.courses_started" },
                { text: "Cursos aprobados", value: "info_statistics.courses_completed" },
                { text: "Cursos reprobados", value: "info_statistics.failed_courses" },
                { text: "Rutas iniciadas", value: "info_statistics.registered_routes" },
                { text: "Insignias obtenidas", value: "info_statistics.insignia" },
                { text: "Rutas reprobadas", value: "info_statistics.failed_routes" },
            ],
            url: this.get,
            desserts: [
                {
                    id: "01",
                    area: "Área de diseño",
                    name: "Andrea Lozada",
                    company: "Woobsing",
                    initcourses: "06",
                    passcourses: "00",
                    failcourses: "02",
                    initroutes: "06",
                    obtainbadge: "04",
                    failroutes: "00",
                },
                {
                    id: "01",
                    area: "Área de diseño",
                    name: "Andrea Lozada",
                    company: "Woobsing",
                    initcourses: "06",
                    passcourses: "00",
                    failcourses: "02",
                    initroutes: "06",
                    obtainbadge: "04",
                    failroutes: "00",
                },
                {
                    id: "01",
                    area: "Área de diseño",
                    name: "Andrea Lozada",
                    company: "Woobsing",
                    initcourses: "06",
                    passcourses: "00",
                    failcourses: "02",
                    initroutes: "06",
                    obtainbadge: "04",
                    failroutes: "00",
                },
                {
                    id: "01",
                    area: "Área de diseño",
                    name: "Andrea Lozada",
                    company: "Woobsing",
                    initcourses: "06",
                    passcourses: "00",
                    failcourses: "02",
                    initroutes: "06",
                    obtainbadge: "04",
                    failroutes: "00",
                },
                {
                    id: "02",
                    area: "Contabilidad",
                    name: "Sofia Aranjuez",
                    company: "Venta Gratis",
                    initcourses: "06",
                    passcourses: "00",
                    failcourses: "02",
                    initroutes: "06",
                    obtainbadge: "04",
                    failroutes: "00",
                },
                {
                    id: "03",
                    area: "Marketing digital",
                    name: "Sofia Aranjuez",
                    company: "GHT",
                    initcourses: "06",
                    passcourses: "00",
                    failcourses: "02",
                    initroutes: "06",
                    obtainbadge: "04",
                    failroutes: "00",
                },
            ],

            headersTabsCompany_old: [
                { text: "No. de Empresas", value: "id" },
                { text: "Empresas activas en Utel X B2B", value: "name" },
                { text: "Usuarios inscritos", value: "statistics.users" },
                { text: "Cursos inscritos", value: "subcourses" },
                { text: "Cursos aprobados", value: "passcourses" },
                { text: "Cursos reprobados", value: "failcourses" },
                { text: "Rutas iniciadas", value: "initroutes" },
                { text: "Rutas completadas", value: "completeroutes" },
                { text: "Insignias obtenidas", value: "obtainbadge" },
                { text: "Rutas reprobadas", value: "failroutes" },
            ],

            dessertsCompany: [],
            dessertsArea: [],
            PorcentajeCursos: [],
            PorcentajeRoutes: [],
            PorcentajeAreas: [],
            GraficoEstudiantes: [],
            estudiantesActivosCount: 0,
            aprobadosUltimoMesCount: 0,
            clientesCount: 0,

            chartOptions: {
                chart: {
                    height: 350,
                    type: "line",
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "straight",
                },
                title: {
                    text: "",
                    align: "left",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                grid: {
                    row: {
                        colors: ["#ffffff", "transparent"], // takes an array which will be repeated on columns
                        opacity: 0.5,
                    },
                    column: {
                        colors: ["#ffffff", "#ffffff"],
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: [
                        "Semana 1",
                        "Semana 2",
                        "Semana 3",
                        "Semana 4",
                    ],
                },
            },

            //   seriesCursosInicio: this.PorcCursosInicio,
            chartOptionsCursosInicio: {
                chart: {
                    height: 350,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 15,
                            size: "70%",
                        },

                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                fontSize: "4em",
                                fontWeight: "bold",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: ["Cursos iniciados"],
            },

            //   seriesCursosInicio: this.PorcCursosInicio,
            chartOptionsCursosAprobados: {
                chart: {
                    height: 350,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 15,
                            size: "70%",
                        },

                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                fontSize: "4em",
                                fontWeight: "bold",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: ["Cursos Aprobados"],
            },

            series: [],
            seriesCursosFin: [80],
            chartOptionsCursosFin: {
                chart: {
                    height: 350,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 15,
                            size: "70%",
                        },

                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                fontSize: "4em",
                                fontWeight: "bold",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: ["Cursos finalizados"],
            },

            seriesRutasInicio: [90],
            chartOptionsRutasInicio: {
                chart: {
                    height: 350,
                    type: "radialBar",
                    labels: ["Rutas iniciadas 2"],
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 15,
                            size: "70%",
                        },

                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                fontSize: "4em",
                                fontWeight: "bold",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: ["Rutas iniciadas"],
            },

            chartOptionsUsuariosInscritosXArea: {
                chart: {
                    height: 350,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 15,
                            size: "70%",
                        },

                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                fontSize: "4em",
                                fontWeight: "bold",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: [""],
            },

            seriesRutasFin: [80],
            chartOptionsRutasFin: {
                chart: {
                    height: 350,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 15,
                            size: "70%",
                        },

                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                fontSize: "4em",
                                fontWeight: "bold",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: ["Rutas finalizados"],
            },

            seriesRutasAprueba: [80],
            chartOptionsRutasAprueba: {
                chart: {
                    height: 350,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 15,
                            size: "70%",
                        },

                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                fontSize: "4em",
                                fontWeight: "bold",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: ["Rutas aprobadas"],
            },

            seriesPlanStudents: [],
            seriesPlanRoutes: [],
            seriesPlanCourses: [],
            seriesPlanRemain: [],
            seriesPlanRemainText: "",
            seriesPlanStudentsNumber: 0,
            seriesPlanRoutesNumber: 0,
            seriesPlanCoursesNumber: 0,
            planStudentsTotal: 0,
            planRoutesTotal: 0,
            planCourseTotal: 0,
            chartOptionsPlan: {
                chart: {
                    height: 200,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -155,
                        endAngle: 155,
                        track: {
                            background: "#E6EBF8",
                        },
                        hollow: {
                            margin: 10,
                            size: "70%",
                        },
                        dataLabels: {
                            showOn: "always",
                            name: {
                                offsetY: -25,
                                show: true,
                                color: "#555555",
                                fontSize: "1em",
                                fontWeight: "500",
                            },
                            value: {
                                color: "#4000BC",
                                offsetY: -5,
                                fontFamily: "Work Sans",
                                fontSize: "2.5em",
                                fontWeight: "700",
                                show: true,
                            },
                        },
                    },
                },
                stroke: {
                    lineCap: "round",
                },
                colors: ["#1FC41C", "#E91E63", "#9C27B0"],
                labels: [""],
            },
        };
    },
    mounted() {
        this.indexDashboard();
        this.getDataArea();
        this.getDataCompany();
        this.studentsDashboard();
        this.coursesDashboard();
        this.routesDashboard();
        this.planesDashboard();
        this.getWordpressCourseCategory();
        this.filtrarXAreas();
    },
    methods: {
        indexDashboard() {
            axios
                .get(`${this.urldatacompany}?withUsers=true`)
                .then((dataCompany) => {
                    if (dataCompany == null) return;

                    this.estudiantesActivosCount =
                        dataCompany.data[0]["usuarios"];
                    this.aprobadosUltimoMesCount =
                        dataCompany.data[1]["cursos"]["count"];
                    this.insigniastotal = dataCompany.data[2]["insignias"];
                    this.clientesCount = dataCompany.data[3]["clientes"];
                });
        },

        studentsDashboard() {
            axios
                .get(`${this.urldatastudents}?withUsers=true`)
                .then((resGraphics) => {
                    this.GraficoEstudiantes = resGraphics.data[0].studentsCount;
                });
        },
        coursesDashboard() {
            axios
                .get(`${this.urldatacourses}?withUsers=true`)
                .then((resGraphics) => {
                    this.PorcentajeCursos = resGraphics.data[0].cursos;
                });

            axios
                .get(`${this.urlplanesgrafica}?withUsers=true`)
                .then((resPlanesGraphics) => {
                    const dataFinal = resPlanesGraphics.data;
                    let data = [];
                    dataFinal.forEach(function (e) {
                        data.push(e.totalCursos);
                    });

                    this.series = [
                        {
                            name: "Cantidad de cursos",
                            data: data,
                        },
                    ];
                });
        },
        routesDashboard() {
            axios
                .get(`${this.urldataroutes}?withUsers=true`)
                .then((resGraphics) => {
                    this.PorcentajeRoutes = resGraphics.data[0].routes;
                });
        },
        planesDashboard() {
            axios
                .get(`${this.urldataplanes}?withUsers=true`)
                .then((resGraphics) => {
                    if (resGraphics == null) return;
                    this.seriesPlanStudentsNumber =
                        resGraphics.data[0].planes["estudiantes"];
                    this.seriesPlanRoutesNumber =
                        resGraphics.data[0].planes["rutas"];
                    this.seriesPlanCoursesNumber =
                        resGraphics.data[0].planes["cursos"];

                    this.planStudentsTotal =
                        resGraphics.data[0].planes["estudiantesXPlan"];
                    this.planRoutesTotal =
                        resGraphics.data[0].planes["rutasXPlan"];
                    this.planCourseTotal =
                        resGraphics.data[0].planes["cursosXPlan"];
                    this.seriesPlanStudents = [
                        Math.round(
                            (this.seriesPlanStudentsNumber /
                                this.planStudentsTotal) *
                                100
                        ),
                    ];
                    this.seriesPlanRoutes = [
                        Math.round(
                            (this.seriesPlanRoutesNumber /
                                this.planRoutesTotal) *
                                100
                        ),
                    ];
                    this.seriesPlanCourses = [
                        Math.round(
                            (this.seriesPlanCoursesNumber /
                                this.planCourseTotal) *
                                100
                        ),
                    ];
                    this.seriesPlanRemain = [
                        resGraphics.data[0].planes["tiempo_restante"].split(
                            " "
                        )[0],
                    ];

                    this.seriesPlanRemainText =
                        resGraphics.data[0].planes["tiempo_restante"];
                });
        },

        getDataCompany() {
            axios
                .get(`${this.urldataclient}?withUsers=true`)
                .then((resCompany) => {
                    if (resCompany == null) return;

                    this.dessertsCompany = resCompany.data[0]["clients"];
                });
        },
        getDataArea() {
            axios.get(`${this.urldataarea}?withUsers=true`).then((resArea) => {
                if (resArea == null) return;
                this.dessertsArea = resArea.data;
                
            });
        },
        checkEvent(event, typeValue) {
            const value = event.target.value;
            axios
                .get(
                    `${this.datagraphics}?withUsers=true&query=${value}&typeQuery=${typeValue}`
                )
                .then((resGraphics) => {
                    this.GraficoEstudiantes = resGraphics.data[3].studentsCount;
                });
        },
        selectCompanyXPlan(val) {
            axios
                .get(
                    `${this.urldataplanes}/${event.target.value}?withUsers=true`
                )
                .then((resGraphics) => {
                    if (resGraphics == null) return;

                    this.seriesPlanStudentsNumber =
                        resGraphics.data[0].planes["estudiantes"];
                    this.seriesPlanRoutesNumber =
                        resGraphics.data[0].planes["rutas"];
                    this.seriesPlanCoursesNumber =
                        resGraphics.data[0].planes["cursos"];

                    this.planStudentsTotal =
                        resGraphics.data[0].planes["estudiantesXPlan"];
                    this.planRoutesTotal =
                        resGraphics.data[0].planes["rutasXPlan"];
                    this.planCourseTotal =
                        resGraphics.data[0].planes["cursosXPlan"];
                    this.seriesPlanStudents = [
                        Math.round(
                            (this.seriesPlanStudentsNumber /
                                this.planStudentsTotal) *
                                100
                        ),
                    ];
                    this.seriesPlanRoutes = [
                        Math.round(
                            (this.seriesPlanRoutesNumber /
                                this.planRoutesTotal) *
                                100
                        ),
                    ];
                    this.seriesPlanCourses = [
                        Math.round(
                            (this.seriesPlanCoursesNumber /
                                this.planCourseTotal) *
                                100
                        ),
                    ];
                    this.seriesPlanRemain = [
                        resGraphics.data[0].planes["tiempo_restante"].split(
                            " "
                        )[0],
                    ];

                    this.seriesPlanRemainText =
                        resGraphics.data[0].planes["tiempo_restante"];
                });
        },
        filtrarPorCliente(val, typeValue) {
            const value = val.target.value;
            axios
                .get(
                    `${this.urlplanesgrafica}?withUsers=true&query=${value}&typeQuery=${typeValue}`
                )
                .then((resPlanesGraphics) => {
                    const dataFinal = resPlanesGraphics.data;
                    let data = [];
                    dataFinal.forEach(function (e) {
                        data.push(e.totalCursos);
                    });

                    this.series = [
                        {
                            name: "Cantidad de cursos",
                            data: data,
                        },
                    ];
                });

            axios
                .get(
                    `${this.urldatacourses}?withUsers=true&queryClient=${value}`
                )
                .then((resGraphics) => {
                    this.PorcentajeCursos = resGraphics.data[0].cursos;
                });
        },
        filtrarEstudiantePorCliente(val) {
            const value = val.target.value;
            axios
                .get(
                    `${this.urldatastudents}?withUsers=true&filterClient=${value}`
                )
                .then((resGraphics) => {
                    console.log(
                        "En la url " +
                            this.urldatastudents +
                            " aparece " +
                            resGraphics
                    );
                    this.GraficoEstudiantes = resGraphics.data[0].studentsCount;
                });
        },
        selectCompanyXRoute(val) {
            const value = val.target.value;

            axios
                .get(
                    `${this.urldataroutes}?withUsers=true&queryClient=${value}`
                )
                .then((resGraphics) => {
                    this.PorcentajeRoutes = resGraphics.data[0].routes;
                });
        },
        filtrarAreasXEmpresa(val) {
            const value = val.target.value;

            axios
                .get(`${this.urldataarea}?withUsers=true&query=${value}`)
                .then((resArea) => {
                    if (resArea == null) return;
                    this.dessertsArea = resArea.data;
                });

            this.filtrarXAreas(val);
        },
        filtrarXAreas(val = null) {
            let value = null;

            if (val != null) {
                value = val.target.value;
            }

            axios
                .get(`${this.allareas}?withUsers=true&queryXArea=${value}`)
                .then((resDataArea) => {
                    if (resDataArea == null) return;
                    // Listado de areas
                    console.log(resDataArea.data[0].areaFilter["userXArea"]);
                    this.dessertsGraphicArea =
                        resDataArea.data[0].areaFilter["dataFilter"];
                    this.PorcentajeAreas =
                        resDataArea.data[0].areaFilter["userXArea"];
                });
        },
        filtrarPorOrden(val) {
            const value = val.target.value;
            axios
                .get(
                    `${this.urldataclient}?withUsers=true&filterOrder=${value}`
                )
                .then((resCompany) => {
                    if (resCompany == null) return;
                    this.dessertsCompany = resCompany.data[0]["clients"];
                });
        },
        filtrarPorPalabra(val) {
            axios
                .get(`${this.urldataclient}?withUsers=true&query=${val}`)
                .then((resCompany) => {
                    if (resCompany == null) return;
                    this.dessertsCompany = resCompany.data[0]["clients"];
                });
        },
        getWordpressCourseCategory() {
            axios.get("/search/category").then((res) => {
                console.log(res.data);
                this.categories = res.data;
            });
        },
        filtrarPorCategoria(val) {
            const value = val.target.value;

            axios
                .get(
                    `${this.urldatacourses}?withUsers=true&filterByCategory=${value}`
                )
                .then((resGraphics) => {
                    this.PorcentajeCursos = resGraphics.data[0].cursos;
                });

            axios
                .get(
                    `${this.urlplanesgrafica}?withUsers=true&filterByCategory=${value}`
                )
                .then((resPlanesGraphics) => {
                    const dataFinal = resPlanesGraphics.data;
                    let data = [];
                    dataFinal.forEach(function (e) {
                        data.push(e.totalCursos);
                    });

                    this.series = [
                        {
                            name: "Cantidad de cursos",
                            data: data,
                        },
                    ];
                });
        },
    },
};
</script>
